import { apiPlugin, storyblokInit } from '@storyblok/react/rsc'

import Audioplayer from '@/components/01-atoms/Audioplayer/Blok'
import Avatar from '@/components/01-atoms/Avatar/Blok'
import Button from '@/components/01-atoms/Button/Blok'
import Forminput from '@/components/01-atoms/Forminput/Blok'
import Formselect from '@/components/01-atoms/Formselect/Blok'
import Formtoggle from '@/components/01-atoms/Formtoggle/Blok'
import Gatecontent from '@/components/01-atoms/Gatecontent/Blok'
import Griditem from '@/components/01-atoms/Griditem/Blok'
import Groupstylepanel from '@/components/01-atoms/GroupStylePanel/Blok'
import IFrame from '@/components/01-atoms/IFrame/Blok'
import ImageHolder from '@/components/01-atoms/ImageHolder/Blok'
import Jotformiframe from '@/components/01-atoms/Jotformiframe/Blok'
import RichText from '@/components/01-atoms/RichText/Blok'
import Tag from '@/components/01-atoms/Tag/Blok'
import TextBlok from '@/components/01-atoms/TextBlock/Blok'
import Ticker from '@/components/01-atoms/Ticker/Blok'
import VideoHolder from '@/components/01-atoms/VideoHolder/Blok'
//import AdviserctaBlok from '@/components/02-molecules/Advisercta/Blok'
import Assettext from '@/components/02-molecules/Assettext/Blok'
import Avatargroup from '@/components/02-molecules/Avatargroup/Blok'
import Brucebanner from '@/components/02-molecules/Brucebanner/Blok'
import CTABlock from '@/components/02-molecules/CTAblock/Blok'
import Featurecards from '@/components/02-molecules/Featurecards/Blok'
import Featuretabs from '@/components/02-molecules/Featuretabs/Blok'
import FormRow from '@/components/02-molecules/FormRow/Blok'
import Gallarytext from '@/components/02-molecules/Gallarytext/Blok'
import Gridpanel from '@/components/02-molecules/Gridpanel/Blok'
import Herobanner from '@/components/02-molecules/Herobanner/Blok'
import InteractiveMap from '@/components/02-molecules/InteractiveMap/Blok'
import Logoslider from '@/components/02-molecules/Logoslider/Blok'
import PartnerList from '@/components/02-molecules/PartnerList/Blok'
import Reviewslider from '@/components/02-molecules/Reviewslider/Blok'
import Tabtext from '@/components/02-molecules/Tabtext/Blok'
import Testimonies from '@/components/02-molecules/Testimonies/Blok'
import Assetbanner from '@/components/03-organisms/Assetbanner/Blok'
import Featuredarticles from '@/components/03-organisms/Featuredarticles/Blok'
import Footer from '@/components/03-organisms/Footer/Blok'
import Form from '@/components/03-organisms/Form/Blok'
import Imagecardgrid from '@/components/03-organisms/Imagecardgrid/Blok'
import Imageslider from '@/components/03-organisms/Imageslider/Blok'
import Relatedarticles from '@/components/03-organisms/Relatedarticles/Blok'
import Searchfindcomponent from '@/components/03-organisms/Searchfindcomponent/Blok'
import Searchnavigation from '@/components/03-organisms/Searchnavigation/Blok'
import ServiceGrid from '@/components/03-organisms/ServiceGrid/Blok'
import Videoslider from '@/components/03-organisms/Videoslider/Blok'
import Advisor from '@/components/04-templates/Advisor/Blok'
import Article from '@/components/04-templates/Article/Blok'
import Businessstory from '@/components/04-templates/Businessstory/Blok'
import Industry from '@/components/04-templates/Industry/Blok'
import Memberdetails from '@/components/04-templates/Memberdetails/Blok'
import Office from '@/components/04-templates/Office/Blok'
import Service from '@/components/04-templates/Service/Blok'
import Sidenavsidenavtemplate from '@/components/04-templates/Sidenavtemplate/Blok'
import Page from '@/components/05-pages/Page/Page'
import Search from '@/components/05-pages/Search/Search'
import FallbackComponent from '@/components/FallbackComponent'

import Calculatorresultskeyitem from '../components/01-atoms/Calculatorresultskeyitem/Blok'
import Messagepanel from '../components/01-atoms/Messagepanel/Blok'
import Calculatorresultskey from '../components/02-molecules/Calculatorresultskey/Blok'
import OfficeDetails from '../components/02-molecules/OfficeDetails/Blok'
import sponsorSlider from '../components/02-molecules/SponsorSlider/Blok'
import Thehulk from '../components/03-organisms/Thehulk/Blok'
import Advanceoffice from '../components/04-templates/Advanceoffice/Blok'
import Calculator from '../components/04-templates/Calculator/Blok'
import { initStoryblokApi } from './storyblok-api'

storyblokInit({
  accessToken: process.env.NEXT_PUBLIC_SB_PREVIEW_TOKEN!,
  use: [apiPlugin],
  apiOptions: { region: 'ap', cache: { type: 'memory' }, timeout: 10000, maxRetries: 3 },
  components: {
    // atoms
    calculatorResultsKeyItem: Calculatorresultskeyitem,
    messagePanel: Messagepanel,
    Ticker: Ticker,
    button: Button,
    avatar: Avatar,
    tag: Tag,
    rich_text: RichText,
    richtext: RichText,
    image_holder: ImageHolder,
    video_holder: VideoHolder,
    grid_item: Griditem,
    textContainer: TextBlok,
    GatedContent: Gatecontent,
    iframe: IFrame,
    formInput: Forminput,
    formSelect: Formselect,
    formToggle: Formtoggle,
    audioPlayer: Audioplayer,
    groupStylePanel: Groupstylepanel,
    Jotform: Jotformiframe,
    // molecules
    calculatorResultsKey: Calculatorresultskey,
    CTAblock: CTABlock,
    asset_text: Assettext,
    herobanner: Herobanner,
    feature_tabs: Featuretabs,
    grid_panel: Gridpanel,
    testimonies: Testimonies,
    FormHeroBanner: Brucebanner,
    ReviewSlider: Reviewslider,
    GalleryText: Gallarytext,
    TabText: Tabtext,
    FeatureCards: Featurecards,
    //findOfficeCTA: AdviserctaBlok,
    avatarGroup: Avatargroup,
    formRow: FormRow,
    LogoSlider: Logoslider,
    PartnerList: PartnerList,
    InteractiveMap: InteractiveMap,
    sponsorSlider: sponsorSlider,
    // organisms
    superHeroBanner: Thehulk,
    relatedContent: Relatedarticles,
    imageCardGrid: Imagecardgrid,
    videoSlider: Videoslider,
    ServicesGrid: ServiceGrid,
    AssetBanner: Assetbanner,
    searchNavigation: Searchnavigation,
    searchFindComponent: Searchfindcomponent,
    featuredArticles: Featuredarticles,
    customisableContactForm: Form,
    OfficeDetails: OfficeDetails,
    footer: Footer,
    // pages
    page: Page,
    article: Article,
    business_story: Businessstory,
    service: Service,
    sideNavPage: Sidenavsidenavtemplate,
    adviser: Advisor,
    office: Office,
    search: Search,
    people: Memberdetails,
    industry: Industry,
    Calculator: Calculator,
    advanceOffice: Advanceoffice,
    imageSlider: Imageslider,
  },
  enableFallbackComponent: true,
  customFallbackComponent: FallbackComponent,
})

// Initialize the API after component registration
initStoryblokApi()

// Re-export the API function to maintain backward compatibility
export { getStoryblokApi } from './storyblok-api'
